module.exports = __webpack_public_path__ + "static/media/gclogo.220d332c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/gclogo.svg
// module id = 205
// module chunks = 0